import closeAddinPane from 'owa-addins-store/lib/actions/closeAddinPane';
import getExtensibilityState from 'owa-addins-store/lib/store/getExtensibilityState';
import { orchestrator } from 'satcheljs';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web?path=/packages/common/controls/packages/controls/owa-drawer/README.md&_a=preview
 *	> 'lazyHideFlexPane' import from 'owa-flex-pane' is restricted. Use owa-drawer to adhere to declarative UI best practices for the panes. */
import { lazyHideFlexPane } from 'owa-flex-pane';
import getTabIdFromWindow from 'owa-addins-store/lib/store/getTabIdFromWindow';
import trace from 'owa-trace/lib/trace';
import closeFlexPaneHelper from 'owa-app-pane-group-utils/lib/helpers/closeFlexPaneHelper';
import { isCapabilityEnabled } from 'owa-capabilities';
import { addinsUseDrawerPaneInpopoutsCapability } from 'owa-capabilities-definitions/lib/addinsUseDrawerPaneInpopoutsCapability';

// Registered as an eager orchestrator (not lazy) so that closeAddinPane
// executes synchronously within the Satchel dispatch cycle. A lazy
// orchestrator introduced an async gap that caused race conditions:
// callers would proceed to open a new pane before the old one had
// actually closed.
orchestrator(closeAddinPane, ({ mailboxInfo, targetWindow, isNewFlexPaneOpened }) => {
    try {
        if (isCapabilityEnabled(addinsUseDrawerPaneInpopoutsCapability)) {
            // Only close the drawer pane if no task panes remain for this
            // window. When a non-persistent addin closes while a persistent
            // (pinned) addin is still in the map, we must keep the drawer
            // open so the pinned addin becomes visible again.
            const { taskPanes } = getExtensibilityState(mailboxInfo);
            const tabId: string = getTabIdFromWindow(targetWindow);
            if (
                taskPanes != undefined &&
                (!taskPanes.has(tabId) || taskPanes.get(tabId)?.size === 0 || isNewFlexPaneOpened)
            ) {
                closeFlexPaneHelper('AddinsPane', 'addins', targetWindow);
            }
        } else {
            const { taskPanes } = getExtensibilityState(mailboxInfo);
            const tabId: string = getTabIdFromWindow(targetWindow);
            if (
                taskPanes != undefined &&
                tabId == 'Main' &&
                (!taskPanes.has(tabId) || taskPanes.get(tabId)?.size === 0 || isNewFlexPaneOpened)
            ) {
                closeFlexPaneHelper('AddinsPane', 'addins');
                lazyHideFlexPane.importAndExecute();
            }
        }
    } catch (error) {
        trace.warn('closeAddinPaneOrchestrator: ' + error, 'addins');
    }
});
